
import employeeLogo from "../../images/employee.png";
import moment from "moment";
import html2pdf from "html2pdf.js";

export const SalesReturnPrint = ({ search, items, state }) => {
  // Build HTML content for PDF generation
  const htmlContent = document.createElement("div");
  htmlContent.innerHTML = `
    <div style="padding: 10px; font-family: Arial, sans-serif;">
      <div style="display: flex; align-items: center;">
        <img src="${localStorage.getItem("base_url") || employeeLogo}" width="30" height="30" style="margin-right: 10px;" />
        <h2>${localStorage.getItem("company")}</h2>
      </div>
      <h1 style="text-align: center;">SALES RETURN REPORT</h1>
      
      <p>From: ${search.startDate}</p>
      <p>To: ${search.endDate}</p>
      
      <h3>SHOP</h3>
      <p>${localStorage.getItem("company") || ""}</p>
      <p>${localStorage.getItem("address") || ""}</p>
      <p>${localStorage.getItem("phone") || ""}</p>

      <table border="1" cellpadding="5" cellspacing="0" width="100%" style="margin-top: 20px;">
        <thead>
          <tr>
            <th>#</th>
             <th>Customer</th>
            <th>Credit</th>
            <th>Profit</th>
            <th>Type</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          ${items?.datebook?.map((item, i) => `
            <tr>
              <td>${item.billNumber}</td>
               <td>${item.customer}</td>
              <td>${item.total}</td>
              <td>${item.profit}</td>
              <td>Bill</td>
              <td>${moment.unix(item.created_at).format("DD-MM-YYYY")}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>

      <p style="text-align: right; font-size: 14px; margin-top: 10px;">
        Total Amount: ${state.credit || ""}
      </p>
      <p style="text-align: right; font-size: 14px;">
        Total Profit: ${state.profit || ""}
      </p>

    </div>
  `;

  const options = {
    margin: 0.5,
    filename: "combined_sales_report.pdf",
    image: { type: "png", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  // Generate PDF and open in a new tab with print preview
  html2pdf()
    .from(htmlContent)
    .set(options)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 100); // Wait a short moment before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
};
